import React from "react";

import styled from "@emotion/styled";
import theme from "../utils/theme";
import {
  mobileQuery,
  tabletQuery,
  laptopQuery,
  desktopQuery,
} from "../utils/mediaqueries";

import UniversityLogo from "./universityLogo/UniversityLogo";
import BackButton from "./backButton/BackButton";

const HeaderWrapper = styled.div(
  {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",

    [mobileQuery]: {
      height: "55px",
    },

    [tabletQuery]: {
      height: "70px",
    },

    [laptopQuery]: {
      height: "65px",
    },

    [desktopQuery]: {
      height: "75px",
    },
  },
  (props) => ({
    [mobileQuery]: {
      borderBottom: props.bordered
        ? `1px solid ${theme.colors.descriptionText}`
        : "null",
      position: props.sticky ? "fixed" : "static",
      top: props.sticky ? 0 : "auto",
    },

    [laptopQuery]: {
      display: props.displayDesktop ? "flex" : "none",
    },

    [desktopQuery]: {
      display: props.displayDesktop ? "flex" : "none",
    },
  }),
);

const Header = ({
  backButton,
  bordered,
  displayDesktop,
  sticky,
  sideMargin,
}) => (
  <HeaderWrapper
    sticky={sticky}
    bordered={bordered}
    displayDesktop={displayDesktop}
  >
    {backButton ? <BackButton sideMargin={sideMargin} /> : <UniversityLogo />}
  </HeaderWrapper>
);

export default Header;
